import type { Agency } from '@saaga/shared/interfaces/agencies.interface'
import type { ReactNode } from 'react'

import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

import { AgencyDetailAvatar } from './agency-detail-avatar.atom'
import { AgencyDetailCategories } from './agency-detail-categories.atom'
import { AgencyDetailStats } from './agency-detail-stats.atom'
import { AgencyVisibilityBadge } from './agency-visibility-badge.atom'

interface AgencyDetailHeaderProps {
  agency: Agency
  isVisibilityBadgeVisible?: boolean
  className?: string
}

export const AgencyDetailHeader = ({
  agency,
  isVisibilityBadgeVisible = false,
  className,
}: AgencyDetailHeaderProps): ReactNode => (
  <div className={cn('agency-detail-header', className)}>
    <div className="flex flex-col md:flex-row md:items-start gap-6">
      <AgencyDetailAvatar agency={agency} />
      <div className="flex-1 min-w-0 space-y-3">
        <div>
          <h1 className="agency-detail-name text-2xl md:text-3xl font-bold tracking-tight">
            {agency.name}
          </h1>
          <div className="flex items-center gap-2 mt-2">
            <Badge variant="secondary" className="agency-detail-org">
              {agency.organization.name}
            </Badge>
            {isVisibilityBadgeVisible && <AgencyVisibilityBadge visibility={agency.visibility} />}
          </div>
        </div>
        <AgencyDetailStats
          rating={agency.rating}
          reviewCount={agency.reviewCount}
          usageCount={agency.usageCount}
          priceRange={agency.priceRange}
        />
        <AgencyDetailCategories categoryList={agency.categoryList} />
      </div>
    </div>
  </div>
)

AgencyDetailHeader.displayName = 'AgencyDetailHeader'
